import React, { useEffect } from "react";
import styles from "../DevelopmentFinanceBlogs/DevelopmentFinanceBlogs.module.scss";
import Footer from "../../components/Footer";
import { useParams } from "react-router-dom";
import NewsContainer from "../../components/NewsContainer";
import MatchingMortgagesC2 from "../../components/MatchingMortgages/MatchingMortgagesC2";
import CompareContainerC2 from "../../components/CompareContainer/CompareContainerC2";
import LoanApplicationC2 from "../../components/LoanApplication/LoanApplicationC2";
import HeroSection from "../../components/HeroSection/HeroSection";
import TestimonialsContainer from "../../components/TestimonialsContainer";
// import TypeOfRequirements from "../../components/TypeOfRequirements";
import CallAdviser from "../../components/CallAdviser";

const CaseStudies2 = () => {
  const { blogId } = useParams();
  console.log(blogId);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.developmentFinanceBlogs}>
      <HeroSection title="Resources" />
      <CompareContainerC2 title="Resources" />
      {/* <TypeOfRequirements title="Resources" /> */}
      <CallAdviser title="Resources" />

      <MatchingMortgagesC2 title="Resources" />
      <NewsContainer title="Resources" />
      <LoanApplicationC2 title="Resources" />
      <TestimonialsContainer title="Resources" />
      <Footer title="Resources" />
    </div>
  );
};

export default CaseStudies2;
